var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BaseTable,{staticClass:"registrations__table",attrs:{"headers":_setup.headers,"items":_setup.items,"total":_setup.total,"loading":_setup.isLoading,"is-show-pagination":""},on:{"change-page":_setup.changePage},scopedSlots:_vm._u([{key:"item.messenger_account",fn:function({ item }){return [_c(_setup.TextCell,{staticClass:"registrations__table-custom__cell-messenger",attrs:{"value":item.messenger_account,"data":{
                isCopyOnClick: true,
                tooltip: 'Скопировать',
                icon:_setup.MESSENGER_ICONS[item.messenger]
            }}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }